import { DashboardContent } from 'src/layouts/dashboard';

import { CustomBreadcrumbs } from 'src/components/custom-breadcrumbs';

import { InvoiceNewEditForm } from '../invoice-new-edit-form';

// ----------------------------------------------------------------------

export function InvoiceCreateView() {
  return (
    <DashboardContent>
      <CustomBreadcrumbs heading="Opret nyt tilbud" sx={{ mb: { xs: 3, md: 5 } }} />

      <InvoiceNewEditForm />
    </DashboardContent>
  );
}
